export function addCommas(number) {
  const str = number.toString().split(".");
  str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return str.join(".");
}

export function formatPlacementIncrease(rank) {
  if (rank === 1) {
    return "FIRST";
  } else if (rank === 2) {
    return "SECOND";
  } else if (rank === 3) {
    return "THIRD";
  } else if (rank === 4) {
    return "FOURTH";
  } else if (rank === 5) {
    return "FIFTH";
  } else if (rank <= 10) {
    return "in the TOP TEN";
  }
}

export function formatPlacementDecrease(rank) {
  if (rank === 2) {
    return "to SECOND";
  } else if (rank === 3) {
    return "to THIRD";
  } else if (rank === 4) {
    return "to FOURTH";
  } else if (rank === 5) {
    return "to FIFTH";
  } else if (rank === 6) {
    return "to SIXTH";
  } else if (rank === 7) {
    return "to SEVENTH";
  } else if (rank === 8) {
    return "to EIGHTH";
  } else if (rank === 9) {
    return "to NINTH";
  } else if (rank === 10) {
    return "to TENTH";
  } else if (rank > 10) {
    return "below the TOP TEN";
  }
}
